import * as Mod1 from "./discourse/admin-community-feedback-plugin-route-map";
import * as Mod2 from "./discourse/community-feedback-route-map";
import * as Mod3 from "./discourse/components/community-feedback-card";
import * as Mod4 from "./discourse/components/community-feedback-composer-fields";
import * as Mod5 from "./discourse/components/community-feedback-gallery";
import * as Mod6 from "./discourse/components/community-feedback-game-filter";
import * as Mod7 from "./discourse/components/community-feedback-media-strip";
import * as Mod8 from "./discourse/components/community-feedback-topic-status";
import * as Mod9 from "./discourse/initializers/community-feedback";
import * as Mod10 from "./discourse/lib/user-display-name";
import * as Mod11 from "./discourse/routes/community-wishes";
import * as Mod12 from "./discourse/templates/community-wishes";
const compatModules = {
  "discourse/admin-community-feedback-plugin-route-map": Mod1,
  "discourse/community-feedback-route-map": Mod2,
  "discourse/components/community-feedback-card": Mod3,
  "discourse/components/community-feedback-composer-fields": Mod4,
  "discourse/components/community-feedback-gallery": Mod5,
  "discourse/components/community-feedback-game-filter": Mod6,
  "discourse/components/community-feedback-media-strip": Mod7,
  "discourse/components/community-feedback-topic-status": Mod8,
  "discourse/initializers/community-feedback": Mod9,
  "discourse/lib/user-display-name": Mod10,
  "discourse/routes/community-wishes": Mod11,
  "discourse/templates/community-wishes": Mod12,
};
export default compatModules;
